import React, { useState, useEffect, useContext } from "react";
import { Modal,Spinner } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { getApiService } from "../services/ApiService"; // st48236 - to handle loading state for confirmation popup
import '../../src/styles/billingConfirmation.css';
import paymentConfirmImg from '../assets/images/Payment-Confirm/confirm.svg';
import paymentConfirmImgQ5 from '../assets/images/Payment-Confirm/confirm-Q5.svg';
import Cookies from 'js-cookie';
import { GetPayLoad } from "../services/PayLoadStorage";
import { toast } from 'react-toastify'; // st48236 - to handle loading state for confirmation popup

const Processedpayments = ({ columns, rows, confirmationlbl, nodatatext, eftwebcontent, eftcontent, debitcontent, serviceError }) => {
    const Payload = GetPayLoad('PayLoad');
    const [confirmationPayPopupModal, setConfirmationPymntsPopupModal] = useState(false);
    const [transactionDetails, setTransactionDetails] = useState([]);
    // st48236 - to handle loading state for confirmation popup - start
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region"   : Payload?.region
    };
    // st48236 - to handle loading state for confirmation popup - end

    const handleCloseConfirmationPymntsPopupClick = () => {
        setConfirmationPymntsPopupModal(false); 
    };

    const formatDate = (date) => {
		if (!date) return "";
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
		const day = String(date.getDate()).padStart(2, "0");
		return month + '/' + day + '/' + year;
	};

    const openConfirmationPage = (e, data_source, conf_num,pymt_type,schedule_date,amt,lastfournum,transid) => {    
        let current_date = formatDate(new Date());        
        // st48236 - to handle loading state for confirmation popup - start
        const targetBillingDetailsUrl = process.env.REACT_APP_GET_CONFIRMATION_PAYMENT_DETAILS_ENDPOINT;
        getApiService(baseUrl, targetBillingDetailsUrl, { cim: Payload?.cim, conf_num: transid,'source':data_source,carrier:Payload?.owning_carrier,'last_4':lastfournum?.slice(-4)}, headers)
            .then((response) => {
                if (response?.data?.statusCode !== 200) {
                    toast.error(serviceError);
                }else{
                    const result = response.data.data;  
                    pymt_type = result?.type || pymt_type;
                    schedule_date = result?.entry_date ? formatDate(new Date(result.entry_date)) : formatDate(new Date(result.settlement_date));
                    const transactionDetails = [
                        { label: (confirmationlbl ? confirmationlbl[3] : 'Confirmation Number'), value: (conf_num)?conf_num:'' },
                        { label: (confirmationlbl ? confirmationlbl[4] : 'Date'), value: (current_date)?current_date:'' },
                        { label: (confirmationlbl ? confirmationlbl[5] : 'Type of Transaction'), value: (pymt_type) ? pymt_type !== 'EFT' ? (Cookies.get('owningCarrier') === 'Q5' ? debitcontent : pymt_type) : (Cookies.get('owningCarrier') === 'Q5' ? eftcontent : pymt_type) : '' },
                        { label: (confirmationlbl ? confirmationlbl[6] : 'Status'), value: (confirmationlbl ? confirmationlbl[9] : 'Success'), isStatus: true },
                        { label: (confirmationlbl ? confirmationlbl[7] : 'Scheduled For'), value: (schedule_date)?schedule_date:'' },
                        { label: (confirmationlbl ? confirmationlbl[8] : 'Payment Amount'), value: (amt)?amt:'' }
                    ];
                    setTransactionDetails(transactionDetails);
                    setConfirmationPymntsPopupModal(true);
                }
            })
            .catch(error => {
                toast.error(serviceError);
            });
        // st48236 - to handle loading state for confirmation popup - end        
    };

    return (
        <>
            <Modal size="x1" show={confirmationPayPopupModal} onHide={handleCloseConfirmationPymntsPopupClick}>
                <Modal.Header className={`multipleaccounts pb-4 ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
                    <Modal.Title>
                        {/* <h4 style={{ color: '#110081' }}>Cancel Payment</h4> */}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div tabIndex={0} className="col-12 paymemt-confrm">
                        <div className="text-center">
                            <img src={Cookies.get('owningCarrier') === 'Q5' ? paymentConfirmImgQ5 : paymentConfirmImg} alt="Payment confirmed" className="img-fluid" />
                            <h4 className="mb-2 mt-3 fw-semibold payment-success-title">{confirmationlbl ? confirmationlbl[0] : 'Payment Successful!'}</h4>

                            <p className="mt-2 mb-2 text-black payment-process">
                                {confirmationlbl ? confirmationlbl[1] : 'Your payment has been processed successfully'}
                            </p>
                        </div>
                        <div className='mt-4 d-grid justify-content-xl-center justify-md-center'>
                            <div className="confrm-box rounded-4 p-3">
                                <p className="mb-3 fw-semibold text-black">{confirmationlbl ? confirmationlbl[2] : 'Transaction Details'}</p>

                                {transactionDetails.map((detail, index) => (
                                    
                                    <div key={index} className="col-12 d-flex mt-2">
                                        <div className="text-start col-6">
                                            <label className="detail-label">{detail.label}</label>
                                        </div>
                                        <div className="text-end col-6 fw-semibold">
                                            {detail.isStatus ? (
                                                <button tabIndex={-1} className="btn btn-success btn-sm confirmationbtn">
                                                    <i className="fe fe-check fe-11 me-1"></i>
                                                    {detail.value}
                                                </button>
                                            ) : (
                                                <label className="detail-value">{detail.value}</label>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <table tabIndex={0} className="table table-striped" style={{ marginLeft: '' }}>
                <thead className="sticky-top">
                    <tr>
                        {
                            columns && columns?.map((item) => <th scope="col">{item}</th>)
                        }
                    </tr>
                </thead>
                <tbody>
                    {rows?.length === 0 ? (
                        <td colSpan={6} className="fw-semibold">
                            <div className="d-flex px-2">
                                <div className="col-12 mb-2">
                                    <h6 className="paymenthistorymodal">{nodatatext}</h6>
                                </div>
                            </div>
                        </td>
                    ) : (
                        rows && rows?.map((item, index) => <tr key={index} className="border-bottom">
                            <td>{item.event_date}</td>
                            <td>{(item.type === 'EFT via Web' && Cookies.get('owningCarrier') === 'Q5') ? eftwebcontent : item.type}</td>
                            <td>{item.name}</td>
                            <td  
                                tabIndex={item.conf_num !== 'N/A' ? 0 : -1} 
                                className={
                                    item.conf_num === 'N/A' 
                                        ? '' 
                                        : Cookies.get('owningCarrier') === 'Q5' 
                                            ? 'anchor-text anchor-text-q5' 
                                            : 'text-decoration-underline'
                                }
                                style={{ cursor: item.conf_num == 'N/A'?'':'pointer' }}
                                onClick={(e) => item.conf_num != 'N/A' && openConfirmationPage(e, item?.data_source, item?.conf_num, item?.pymt_type,item?.event_date,item?.amount,item.last4,item.trans_id)} // st48236 - to handle loading state for confirmation popup
                                onKeyDown={(e) => item.conf_num != 'N/A' && openConfirmationPage(e, item?.data_source, item?.conf_num, item?.pymt_type,item?.event_date,item?.amount,item.last4,item.trans_id)} // st48236 - to handle loading state for confirmation popup
                            >
                                {item.conf_num}
                            </td>
                            <td>{item.last4}</td>
                            <td>{item.amount}</td>
                        </tr>))}
                </tbody>
            </table>
        </>
    )
}

export default Processedpayments;